import { useState } from 'react';
import { Checkbox, ConfirmationModal, Typography } from 'seagull';
import { getTestIds } from 'seagull/utils/TestIds';
import { LegalTermsUsedIn } from "../../../models/legal-terms/model";
import styles from "./PropagationModal.module.scss";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const {
  PropagationModalTID
} = getTestIds();
const usedInLabels = {
  [LegalTermsUsedIn.Draft]: 'Apply changes to all drafts using this document',
  [LegalTermsUsedIn.ProposalTemplate]: 'Apply changes to all proposal templates using this document'
};
const usedInTestIds = {
  [LegalTermsUsedIn.Draft]: PropagationModalTID.DraftCheckbox,
  [LegalTermsUsedIn.ProposalTemplate]: PropagationModalTID.ProposalTemplateCheckbox
};
export const PropagationModal = _ref => {
  let {
    usedIn,
    isSaving,
    onConfirm,
    onCancel
  } = _ref;
  const [updateRelationshipDrafts, setUpdateRelationshipDrafts] = useState(false);
  const [updateProposalTemplates, setUpdateProposalTemplates] = useState(false);
  const handleConfirm = () => {
    onConfirm({
      updateRelationshipDrafts,
      updateProposalTemplates
    });
  };
  return /*#__PURE__*/_jsx(ConfirmationModal, {
    title: "Update existing documents",
    width: "600px",
    testId: PropagationModalTID.Root(),
    textAlignCenter: false,
    content: /*#__PURE__*/_jsxs("div", {
      className: styles.propagationContent,
      children: [/*#__PURE__*/_jsx(Typography, {
        children: "This document is already used in existing proposal drafts and proposal templates."
      }), /*#__PURE__*/_jsx(Typography, {
        children: "You can choose to update them with your recent changes:"
      }), /*#__PURE__*/_jsx("div", {
        className: styles.propagationCheckboxes,
        children: [...usedIn].sort().map(usedInValue => /*#__PURE__*/_jsx(Checkbox, {
          inline: true,
          testId: usedInTestIds[usedInValue](),
          checked: usedInValue === LegalTermsUsedIn.Draft ? updateRelationshipDrafts : updateProposalTemplates,
          onChange: e => {
            if (usedInValue === LegalTermsUsedIn.Draft) {
              setUpdateRelationshipDrafts(e.target.checked);
            } else {
              setUpdateProposalTemplates(e.target.checked);
            }
          },
          children: /*#__PURE__*/_jsx(Typography, {
            children: usedInLabels[usedInValue]
          })
        }, usedInValue))
      })]
    }),
    primaryButtonLabel: "Save changes",
    secondaryButtonLabel: "Cancel",
    primaryButtonLoading: isSaving,
    onPrimaryButtonClick: handleConfirm,
    onSecondaryButtonClick: onCancel
  });
};